import { useEffect } from "react";

/**
 * Calls `handler` when a mousedown or touchstart event happens outside `ref`.
 * Only attaches listeners while `active` is true.
 *
 * Note: `event` and `onPointerDown` are NOT React-tracked dependencies –
 * `event` is the DOM event passed to the handler, and `onPointerDown` is
 * defined inside the effect. The effective deps `[ref, active, handler]`
 * are correct; we silence the linter's false positive below.
 */
export function useClickOutside(ref, active, handler) {
  useEffect(() => {
    if (!active) return undefined;

    const onPointerDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("touchstart", onPointerDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("touchstart", onPointerDown);
    };
  }, [ref, active, handler]);
}
